import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromSpatialModellerStore from 'src/app/spatial-modeller-store';
import * as fromGazetteerStore from 'src/app/shared/atlas-gazetteer/store';
import * as fromUIStore from 'src/app/core/store';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AiPromptTemplateLibraryService } from 'src/app/core/services/ai-prompt-template-library.service';

import { AiAssistantDialogComponent } from '../../../ai-assistant/ai-assistant-dialog/ai-assistant-dialog.component';
import { DialogWidth } from 'src/app/shared/atlas-dialog/enums/dialog-width.enum';
import * as fromCore from 'src/app/core/store';
import { Subscription } from 'rxjs';
import { isAiAssistantDialogOpen } from 'src/app/shared/utils/dialog-utils';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'atlas-spatial-modeller-reports-panel',
    templateUrl: './sm-reports-panel.component.html',
    styleUrls: ['./sm-reports-panel.component.less'],
    standalone: false
})
export class SpatialModellerReportsPanelComponent implements OnInit, OnDestroy {
  areTestStatsAvailable$ = this.spatialModellerStore$.select(
    fromSpatialModellerStore.getAreTestStatsAvailable
  );

  stats$ = this.spatialModellerStore$.select(
    fromSpatialModellerStore.getSpatialModellerStats
  );

  isSelectedPointEmpty$ = this.gazetteerStore$.select(
    fromGazetteerStore.getIsSelectedPointEmpty
  );
  isSimpleStatsView$ = this.UIStore$.select(fromUIStore.getIsSimpleStatsView);

  isAiAssistantEnabled$ = this.UIStore$.select(fromCore.isAiAssistantEnabled);

  private subscription = new Subscription();

  public currentStats: any;
  private currentSupplyPoint: any;

  constructor(
    private spatialModellerStore$: Store<fromSpatialModellerStore.State>,
    private gazetteerStore$: Store<fromGazetteerStore.State>,
    private UIStore$: Store<fromUIStore.State>,
    private dialogService: DialogService,
    private aiPromptService: AiPromptTemplateLibraryService,
    private dialog: MatDialog
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.spatialModellerStore$
        .select(fromSpatialModellerStore.getSpatialModellerStats)
        .subscribe((stats) => {
          if (stats) {
            this.currentStats = stats;
          }
        })
    );

    this.subscription.add(
      this.spatialModellerStore$
        .select(fromSpatialModellerStore.getSpatialModellerSupplyPoint)
        .subscribe((supplypoint) => {
          if (supplypoint) {
            this.currentSupplyPoint = supplypoint;
          }
        })
    );
  }

  onAiAssistantClicked(stats: any): void {
    // build prompt from stats

    console.log('attributes', this.currentSupplyPoint);

    var prompt =
      'Write a clear, concise paragraph explaining the following data. Avoid jargon and be suitable for a non-technical audience. \n\n';

    prompt =
      prompt +
      '**' +
      this.currentSupplyPoint.name +
      '(' +
      this.currentSupplyPoint.supplyId +
      ')' +
      '** \n';

    prompt = prompt + '**Location attributes:**\n';
    prompt = prompt + this.buildLocationAttributesInMarkdown();
    prompt = prompt + '\n\n';
    prompt = prompt + '**Stattistics:**\n';
    prompt = prompt + this.convertStatsDataToMarkDown(this.currentStats);

    // add prompt to the service
    this.aiPromptService.setCurrentPromptText(prompt);

    if (!isAiAssistantDialogOpen(this.dialog)) {
      this.dialogService.show(AiAssistantDialogComponent, {
        width: DialogWidth.Large,
        panelClass: 'dialog-full-width-height',
        disableClose: true,
        hasBackdrop: false
      });
    }
  }

  private buildLocationAttributesInMarkdown() {
    const header = '| Name | Value |\n| ----------- | ----------- |';
    let rows = '';

    rows += `| Supply Key | ${this.currentSupplyPoint?.supplyId ?? ''} |\n`;
    rows += `| Supply Fascia | ${this.currentSupplyPoint?.fascia ?? ''} |\n`;
    rows += `| Closed | ${this.currentSupplyPoint?.isClosed ?? ''} |\n`;

    if (
      this.currentSupplyPoint.attributes &&
      Array.isArray(this.currentSupplyPoint.attributes)
    ) {
      for (const attr of this.currentSupplyPoint.attributes) {
        const key = attr.key;
        const value = attr.value;
        rows += `| ${key} | ${value ?? ''} |\n`;
      }
    }

    return `${header}\n${rows}`;
  }

  private convertStatsDataToMarkDown(currentStats: any | null) {
    if (currentStats) {
      if (currentStats && currentStats.length > 0) {
        const header = '| Name | Value |\n| ----------- | ----------- |';
        const rows = currentStats
          .map((data: any) => `| ${data.name} | ${data.value} |`)
          .join('\n');
        return `${header}\n${rows}`;
      }
    }

    return '';
  }
}
